import { render } from "./Briefcase.vue?vue&type=template&id=601ff0cb&scoped=true"
import script from "./Briefcase.vue?vue&type=script&lang=js"
export * from "./Briefcase.vue?vue&type=script&lang=js"

import "./Briefcase.vue?vue&type=style&index=0&id=601ff0cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601ff0cb"]])

export default __exports__